import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ProfileService } from '@pkp/services';
import { catchError, map, Observable, of } from 'rxjs';

export const companyManagerGuard = (): Observable<true | UrlTree> => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  const redirectToProfile = (): UrlTree => router.parseUrl('/desktop/main/profile');

  return profileService.getProfile().pipe(
    map(({ roles }) => {
      const isManager = !!roles?.some(role => role === 'manager' || role === 'director');
      return isManager ? true : redirectToProfile();
    }),
    catchError(() => of(redirectToProfile())),
  );
};
